import { createReducer } from '@reduxjs/toolkit';
import { conversationsActions } from './conversations.actions';
const initialState = {
    lastSearchParams: {
        status: ['open'],
    },
};
export const conversationsReducer = createReducer(initialState, (builder) => builder.addCase(conversationsActions.setLastSearchParams, (state, action) => {
    const { agentIds, channels, directions, limit, offset, queueIds, requesterIds, status, sort, } = action.payload.apiArg;
    const searchParams = Object.assign(Object.assign(Object.assign({}, (typeof agentIds === 'boolean'
        ? {
            assigned: agentIds.toString(),
        }
        : {
            agent: agentIds,
        })), { channel: channels, direction: directions, limit: limit === null || limit === void 0 ? void 0 : limit.toString(), offset: offset === null || offset === void 0 ? void 0 : offset.toString(), queue: queueIds, requester: requesterIds, status: typeof status === 'string'
            ? status
            : status === null || status === void 0 ? void 0 : status.filter((status) => status !== 'awaitingpending') }), (sort ? { sort: Object.values(sort).join(':') } : {}));
    state.lastSearchParams = searchParams;
}));
